import useSessionStorage from './useSessionStroage';

export default useSessionStorage;
